import React from 'react';
import Lottie from 'lottie-react';
import { useMediaQuery } from '@mui/material';
import infoAnimation from '../../lottie/info.json';
import disconnectedAnimation from '../../lottie/disconnected.json';
import { ModalButton } from '../common/AppDialog';
import { LOTTIE_SIZES, lottieContentStyle, lottieFrameStyle, lottieRendererSettings } from '../common/lottieSizing';

export default function StudioLoadError({ onRetry, retrying = false, variant = 'story' }: {
  onRetry: () => void;
  retrying?: boolean;
  variant?: 'story' | 'connection';
}) {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const connection = variant === 'connection';
  return <div className="studio-load-error">
    <div aria-hidden="true" style={lottieFrameStyle(LOTTIE_SIZES.emptyState)}>
      <Lottie animationData={connection ? disconnectedAnimation : infoAnimation} loop={connection} autoplay={!reducedMotion} style={lottieContentStyle} rendererSettings={lottieRendererSettings} />
    </div>
    <div className="studio-load-error-copy" role="alert">
      <h3>{connection ? 'Connection issue' : 'Could not load this story.'}</h3>
      <p>{connection ? 'We couldn’t connect to your story workspace. Please try again.' : 'Please try again.'}</p>
    </div>
    <ModalButton onClick={onRetry} disabled={retrying}>{retrying ? 'Retrying…' : 'Retry'}</ModalButton>
  </div>;
}
